import { createContext } from "react";
const DensityContext = /*#__PURE__*/createContext();
export default DensityContext;